import req from "../http";

const contactInfo = {
  // 取得 聯絡資訊
  getContactInfo(params) {
    return req("get", "/BasicInformation/ContactInfo", params);
  },

  // 取得 聯絡資訊(分頁)
  getContactInfoPaging(params) {
    return req("get", "/BasicInformation/ContactInfo/Paging", params);
  },


  // 新增 聯絡資訊
  postContactInfo(params) {
    return req("post", "/BasicInformation/ContactInfo", params);
  },

  // 更新 聯絡資訊
  putContactInfo(params) {
    return req("put", "/BasicInformation/ContactInfo", params);
  },

  // 刪除 聯絡資訊
  deleteContactInfo(params) {
    return req("delete", "BasicInformation/ContactInfo", params);
  },
};

export default contactInfo;